import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Injector, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

// Rxjs
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { CookieService } from 'ngx-cookie-service';

// Material
import { MatSidenav } from '@angular/material/sidenav';
import { NgxPermissionsService } from 'ngx-permissions';

// Services
import { AuthService } from '@auth/auth.service';
import { WebcomponentsService } from '@core/service/webcomponents.service';
import { MarketingEventEnumeration, MarketingEventService } from '@shared/services';
import { RedirectionService } from '@shared/services/redirection.service';
import { HeaderService } from './header.service';

// Configs
import { HEADER_ROUTES_CONSTANTS } from './configs';

// Models
import { FilterHome } from '@model/pay/filter-home';
import { Rol } from '@model/rol';

// Environments
import { environment } from '@environments/environment';

// Enums
import { COOKIE_ENUMERATION } from '@home/login/configs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit, AfterViewInit {
  @ViewChild('notificationsRef', { static: false }) public notificationWebComponent: ElementRef;
  @ViewChild('sidenav') public sidenav: MatSidenav;
  @ViewChild('sidenav') public sidenavElementRef: ElementRef;

  public userName: string;
  rol: Rol;
  isAuthenticated: boolean;
  token: any;
  user: any;
  permissions: string[];

  public filterPay: string;
  public filterDetail: string;
  public showMenu: boolean;
  private webComponentService: WebcomponentsService;
  private readonly unSubscribe$: Subject<void>;
  public hasActiveLoan: boolean;
  public isProduction: boolean;
  private cookieService: CookieService;
  private marketingEventService: MarketingEventService;
  public showTooltip: boolean;
  public isOptionVisible: boolean;
  public HEADER_ROUTES_CONSTANTS: typeof HEADER_ROUTES_CONSTANTS;

  constructor(
    public authService: AuthService,
    private router: Router,
    private service: HeaderService,
    private roleStoreService: NgxPermissionsService,
    private redirectService: RedirectionService,
    private _changeDetectionRef: ChangeDetectorRef,
    private readonly injector: Injector
  ) {
    this.permissions = [];
    this.showMenu = false;
    this.webComponentService = this.injector.get(WebcomponentsService);
    this.unSubscribe$ = new Subject();
    this.isProduction = environment.production;
    this.hasActiveLoan = true;
    this.isOptionVisible = false;
    this.cookieService = this.injector.get(CookieService);
    this.marketingEventService = this.injector.get(MarketingEventService);
    this.HEADER_ROUTES_CONSTANTS = HEADER_ROUTES_CONSTANTS;
    this.showTooltip = false;

    this.userName = '';

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((navegacion: NavigationEnd) => {
        this.redirectService.registerUrl(navegacion.url);
      });
  }

  ngAfterViewInit(): void {
    this.initNotificationsWebComponent();
  }

  ngOnInit(): void {
    this.rol = new Rol();
    this.filterPay = FilterHome.PAY;
    this.filterDetail = FilterHome.DETAIL;
    this.getUser();
    this.service.getMenuControl().subscribe((status) => {
      if (status?.updateUserInfo) this.getUser();
      this._changeDetectionRef.detectChanges();
    });
  }

  public ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  public toggleOption(): void {
    this.isOptionVisible = !this.isOptionVisible;
  }

  public initNotificationsWebComponent(): void {
    const token = this.authService.token;
    const payload = this.authService.getTokenData(token);
    const notifications = this.notificationWebComponent.nativeElement;

    this.webComponentService.isLoaded$.pipe(takeUntil(this.unSubscribe$)).subscribe({
      next: (loaded) => {
        if (loaded) {
          notifications.ngElementStrategy.componentRef.instance.build({
            clientId: payload.clienteId,
          });
        }
      },
    });
  }

  logout() {
    this.authService.logout();
  }

  getUser() {
    this.service.getUserInformation().subscribe((response: { response: string }) => {
      this.userName = response.response;
      if (this.userName == 'null null') {
        this.userName = '';
      }
    });

    this.rol.roles = this.authService.getRoles();

    for (const rol of this.rol.roles) {
      this.permissions.push(rol.name);
    }

    // es una libreria que cuando se cargan las diferentes pantallas se cargan los roles en los submenus

    // en este momento existen unos roles doomies
    this.roleStoreService.loadPermissions(this.permissions);
  }

  public detectClickOutsideSidenav(event: MouseEvent): void {
    if (!this.showMenu) return;

    const clickedInsideSidenav = this.sidenavElementRef.nativeElement?.contains(event.target);
    if (!clickedInsideSidenav) {
      this.sidenav.close();
      this.showMenu = false;
    }
  }

  public toggleOpenSideNav(): void {
    this.showMenu = !this.showMenu;
    if (this.showMenu) {
      this.sidenav.open();
    } else {
      this.sidenav.close();
    }
  }

  public closeTooltip(): void {
    this.showTooltip = false;
  }

  public redirectRF(): void {
    this.marketingEventService.sendMarketingEvents(MarketingEventEnumeration.LOGIN_RF);
    this.cookieService.set(COOKIE_ENUMERATION.CRFRAP, this.authService.token, 1, '/', environment.domain);
    window.location.href = environment.myCreditsRapiflex;
  }
}
